import React from 'react';

export default function AngleRightIcon({width = '1em', height = '1em', fontSize = '20px'}) {
  return (
    <svg style={{width, height, fontSize}} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.1579 18.5357C15.7806 17.9145 15.7806 16.9067 15.1579 16.2848L8.22229 10.0011L15.1579 3.71737C15.7806 3.09543 15.7806 2.08835 15.1579 1.46645C14.5353 0.844517 13.5267 0.844517 12.904 1.46645L4.83543 8.77598C4.49899 9.11242 4.35063 9.56051 4.37834 10.0011C4.35063 10.4409 4.49899 10.8898 4.83543 11.2262L12.904 18.5358C13.5267 19.1569 14.5352 19.1569 15.1579 18.5357Z' fill='currentColor'/>
    </svg>
  );
}